/**
 * Audit "Add Scripts": Tiendanube runs two Pilcha scripts side by side, the
 * classic one (this loader) and the NubeSDK worker
 * (apps/tiendanube-app/nubesdk), which mounts
 * `<Iframe src=".../embed.html?platform=tiendanube&...">` in the PDP slot with
 * its own try-on button. The loader shares the page with that iframe, so it can
 * see it and avoid a duplicate button.
 */
export const NUBESDK_EMBED_SELECTOR = 'iframe[src*="/embed.html"][src*="platform=tiendanube"]';

export function hasNubeSdkEmbed(root: ParentNode = document): boolean {
  return root.querySelector(NUBESDK_EMBED_SELECTOR) != null;
}
